import React, { createContext, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import Home from './pages/Home/Home'
import SitePage from './pages/SitePage/SitePage'
import ScrollToTop from './ui/ScrollToTop/ScrollToTop'
import CookieNotification from './components/CookieNotification/CookieNotification'
import Oplata from './pages/Oplata/Oplata'
import Success from './pages/Success/Success'

export const AuthContext = createContext(null)

const AuthProvider = ({ children }) => {
  const [showContactUs, setShowContactUs] = useState({
    show: false,
    title: '',
    emailSubject: '',
  })

  return (
    <AuthContext.Provider value={{ showContactUs, setShowContactUs }}>
      {children}
    </AuthContext.Provider>
  )
}

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Switch>
        <Route path="/success" exact component={Success} />
        <SitePage>
          <Route path="/" exact component={Home} />
          <Route path="/oplata" exact component={Oplata} />
        </SitePage>
      </Switch>

      <CookieNotification />
    </AuthProvider>
  )
}

export default App
